import React from 'react';
import { Chip, alpha } from '@mui/material';
import type { ChainStatus } from './types';

export const STATUS_COLORS: Record<ChainStatus, string> = {
  green: '#22c55e',
  yellow: '#eab308',
  red: '#ef4444',
};

export const STATUS_LABELS: Record<ChainStatus, string> = {
  green: 'Normal',
  yellow: 'Watch',
  red: 'Notable',
};

export function worstStatus(statuses: ChainStatus[]): ChainStatus {
  if (statuses.some((s) => s === 'red')) return 'red';
  if (statuses.some((s) => s === 'yellow')) return 'yellow';
  return 'green';
}

export default function StatusChip({ status, label, size = 'small' }: { status: ChainStatus; label?: string; size?: 'small' | 'medium' }) {
  const color = STATUS_COLORS[status];
  return (
    <Chip
      size={size}
      label={label ?? STATUS_LABELS[status]}
      sx={{
        height: size === 'small' ? 20 : 24,
        fontWeight: 700,
        fontSize: size === 'small' ? '0.6875rem' : '0.75rem',
        bgcolor: alpha(color, 0.12),
        color,
        border: `1px solid ${alpha(color, 0.3)}`,
        '& .MuiChip-label': { px: 0.9 },
      }}
    />
  );
}
